// const url = 'http://localhost:7071/graphql';
const url = 'https://ist-api.azurefd.net/graphql';

const productName = 'numris';

export default { url, productName };
